// Auth service for JWT login/refresh using Django SimpleJWT
// Uses API base from env and derives /api root for auth endpoints

const API_V1 = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL) || '/api/bravosim/v1'
const API_ROOT = API_V1.replace(/\/?v1\/?$/, '') || '/api/bravosim'

async function jsonFetch(url, init) {
  const res = await fetch(url, {
    ...(init || {}),
    headers: { 'Content-Type': 'application/json', ...(init && init.headers ? init.headers : {}) },
  })
  const isJson = (res.headers.get('content-type') || '').includes('application/json')
  const body = isJson ? await res.json() : await res.text().catch(() => null)
  if (!res.ok) {
    const msg = (body && (body.detail || body.message)) || `HTTP ${res.status}`
    throw new Error(msg)
  }
  return body
}

export async function loginRequest({ username, password }) {
  const url = `${API_ROOT}/auth/token/`
  return jsonFetch(url, { method: 'POST', body: JSON.stringify({ username, password }) })
}

export async function refreshTokenRequest(refresh) {
  const url = `${API_ROOT}/auth/token/refresh/`
  return jsonFetch(url, { method: 'POST', body: JSON.stringify({ refresh }) })
}
